
<template>
  <div class="appraise">
    <div class="appraiseTop">
      <h3 v-if="data.average_score == 0" style="font-size:16px;">暂无评分</h3>
      <h3 v-else>{{ data.average_score }}<span style="margin-left:3px;">分</span></h3>
      <div @click="toComment(data.title, data.image)" v-if="isToken">
        <img src="./../../../assets/school/edit.png" />
        <span>留下我的观点…</span>
      </div>
    </div>
    <div
      class="appraiseMid"
      :style="{ paddingBottom: data.is_join_study ? '30px' : '113px' }"
    >
      <div v-if="vipCommentData.id || commentList.length > 0">
        <!-- 会员评论 -->
        <div class="appraiseItem" v-if="vipCommentData.id">
          <div class="appraiseItemTop">
            <img v-if="vipCommentData.member_headpic" :src="vipCommentData.member_headpic" />
            <img v-else src="./../../../assets/school/user.png" />
            <div>
              <h4>{{ vipCommentData.member_nickname }}</h4>
              <p>{{ vipCommentData.created_at }}</p>
            </div>
            <div>
              <img
                src="./../../../assets/school/22f.png"
                v-if="vipCommentData.score == 1"
              />
              <img
                src="./../../../assets/school/11f.png"
                v-if="vipCommentData.score == 2"
              />
              <img
                src="./../../../assets/school/33f.png"
                v-if="vipCommentData.score == 3"
              />
              <img
                src="./../../../assets/school/44f.png"
                v-if="vipCommentData.score == 4"
              />
              <img
                src="./../../../assets/school/55f.png"
                v-if="vipCommentData.score == 5"
              />
              <span>{{ vipCommentData.score }}</span>
            </div>
          </div>
          <div
            class="appraiseItemTip"
            v-if="
              vipCommentData.is_delete == 4 || vipCommentData.is_delete == -1
            "
          >
            <span>内容涉及敏感词汇，无法正常展示！</span>
            <img
              src="./../../../assets/school/del2.png"
              @click="delComment(vipCommentData.id)"
            />
          </div>
          <p>{{ vipCommentData.content }}</p>
          <div class="appraiseItemHf" v-if="vipCommentData.is_reply == 1">
            <p>讲师回复：{{ vipCommentData.replies.content }}</p>
            <span>{{ vipCommentData.replies.created_at }}</span>
          </div>
          <span v-if="isToken" @click="isAppraiseDel = !isAppraiseDel"
            >我的评论
            <img src="./../../../assets/school/moreImg.png" />
            <img
              src="./../../../assets/school/delImg.png"
              class="delImg"
              v-if="isAppraiseDel"
              @click="delComment(vipCommentData.id)"
            />
          </span>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <!-- 评论列表 -->
          <div
            class="appraiseItem"
            v-for="(item, index) in commentList"
            :key="index"
          >
            <div class="appraiseItemTop">
              <img v-if="item.member_headpic" :src="item.member_headpic" />
              <img v-else src="./../../../assets/school/user.png" />
              <div>
                <h4>{{ item.member_nickname }}</h4>
                <p>{{ item.created_at }}</p>
              </div>
              <div>
                <img
                  src="./../../../assets/school/22f.png"
                  v-if="item.score == 1"
                />
                <img
                  src="./../../../assets/school/11f.png"
                  v-if="item.score == 2"
                />
                <img
                  src="./../../../assets/school/33f.png"
                  v-if="item.score == 3"
                />
                <img
                  src="./../../../assets/school/44f.png"
                  v-if="item.score == 4"
                />
                <img
                  src="./../../../assets/school/55f.png"
                  v-if="item.score == 5"
                />
                <span>{{ item.score }}</span>
              </div>
            </div>
            <p>{{ item.content }}</p>
            <div class="appraiseItemHf" v-if="item.is_reply == 1">
              <p>讲师回复：{{ item.replies.content }}</p>
              <span>{{ item.replies.created_at }}</span>
            </div>
          </div>
        </van-list>
      </div>
      <div v-else class="noAppraise">
        <img src="./../../../assets/school/commentsTip.png" />
        <p>还没评论!快来抢沙发</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
    },
    id: {
      required: true,
    },
  },
  data() {
    return {
      isToken: false,
      isAppraiseDel: false,
      commentList: [],
      vipCommentData: {},
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      commentUrl: "school/index/comment/list",
    };
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.commentUrl = "school/member/comment/list";
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getVipComment();
    } else {
      this.isToken = false;
      this.commentUrl = "school/index/comment/list";
    }
    this.getCommentList()
  },
  methods: {
    // 获取会员的评价
    getVipComment() {
      this.$api
        .post("school/member/comment/member/list", {
          courses_id: this.id,
        })
        .then((res) => {
          if (res.id) {
            this.vipCommentData = res;
          } else {
            this.vipCommentData = {};
          }
        });
    },
    // 获取评价列表
    getCommentList() {
      this.$api
        .post(this.commentUrl, {
          courses_id: this.id,
          page: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.commentList = this.commentList.concat(res.list);
          this.loading = false;
          if (this.commentList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          }
        });
    },
    // 加载更多
    onLoad() {
      this.page++;
      this.getCommentList();
    },
    // 评价
    toComment(title, image) {
      if (this.data.is_comment) {
        this.$toast("只可评论一次！");
      } else {
        this.$router.push({
          path: "/school/comment",
          query: {
            id: this.id,
            title: title,
            image: image,
          },
        });
      }
    },
    // 删除评论
    delComment(id) {
      this.$dialog
        .confirm({
          title: "确认删除？",
          message: "删除后内容不可恢复，确认删除我的评论？",
          width: "280px",
          confirmButtonColor: "#4E7DF7",
          cancelButtonColor: "#EDF2FE",
          theme: "round-button",
        })
        .then(() => {
          this.$api
            .post("school/member/comment/delete", {
              id: id, //类型：Number  必有字段  备注：评价id
            })
            .then((res) => {
              this.$toast("删除成功！");
              this.$emit("refresh");
              this.getVipComment();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style>
.appraise {
  margin: 0 16px;
}
.appraise .appraiseTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.appraise .appraiseTop h3 {
  color: #404247;
  font-size: 32px;
  margin: 0;
}
.appraise .appraiseTop h3 span {
  font-size: 14px;
}
.appraise .appraiseTop > div {
  width: 180px;
  height: 32px;
  background: #f6f8fd;
  border-radius: 16px;
  display: flex;
  align-items: center;
}
.appraise .appraiseTop > div img {
  width: 16px;
  height: 16px;
  margin: 0 6px 0 16px;
}
.appraise .appraiseTop > div span {
  color: #9ca1ad;
  font-size: 14px;
}
.appraiseMid {
  padding-top: 9px;
  padding-bottom: 30px;
}
.appraiseMid .appraiseItem {
  border-bottom: 1px solid #edf1fa;
  margin-top: 20px;
}
.appraiseMid .appraiseItem .appraiseItemTip {
  height: 24px;
  background: rgba(235, 72, 114, 0.1);
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  margin-top: 8px;
}
.appraiseMid .appraiseItem .appraiseItemTip span {
  font-size: 12px;
  font-weight: 400;
  color: #eb4872;
  line-height: 17px;
}
.appraiseMid .appraiseItem .appraiseItemTip img {
  width: 12px;
  height: 12px;
}
.appraiseMid .appraiseItem .appraiseItemTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.appraiseMid .appraiseItem .appraiseItemTop > img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.appraiseMid .appraiseItem .appraiseItemTop > div:nth-child(2) {
  flex: 1;
  margin: 0 4px;
}
.appraiseMid .appraiseItem .appraiseItemTop > div {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}
.appraiseMid .appraiseItem .appraiseItemTop > div:last-child {
  align-items: center;
}
.appraiseMid .appraiseItem .appraiseItemTop > div h4 {
  color: #404247;
  margin: 0;
}
.appraiseMid .appraiseItem .appraiseItemTop > div p {
  color: #999999;
  margin: 2px 0 0;
}
.appraiseMid .appraiseItem .appraiseItemTop > div img {
  width: 16px;
  height: 16px;
}
.appraiseMid .appraiseItem .appraiseItemTop > div span {
  color: #4e7df7;
  margin-top: 3px;
  font-weight: 700;
}
.appraiseItem > p {
  color: #404247;
  font-size: 15px;
  line-height: 20px;
  margin: 8px 0 16px;
}
.appraiseItem .appraiseItemHf {
  background: #f8f9fd;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 6px;
}
.appraiseItem .appraiseItemHf p {
  color: #404247;
  font-size: 14px;
  line-height: 20px;
}
.appraiseItem .appraiseItemHf span {
  color: #999999;
  font-size: 12px;
}
.appraiseItem > span {
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 12px;
  margin-bottom: 12px;
}
.appraiseItem > span img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.appraiseItem > span .delImg {
  width: 55px;
  height: 25px;
}

.appraise .van-list__finished-text{
  margin-top: 48px;
}

.noAppraise {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noAppraise img {
  width: 235px;
  height: 235px;
}
.noAppraise p {
  font-size: 14px;
  color: #9ca1ad;
  margin-top: 24px;
}
/* 弹窗 */
/* 弹窗 */
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel{
  color: #4E7DF7 !important;
}
</style>